export const PaternityData = {
  leaveid: null,
  parentid: null,
  leavetypeid: 7,
  leavecategoryid: 1,
  leavename: null,
  description: null,
  isallocatebalance: true,
  isautoallocation: false,
  annualbalance: 0,
  monthlyallocate: [
    {
      monthid: 1,
      value: 0,
    },
    {
      monthid: 2,
      value: 0,
    },
    {
      monthid: 3,
      value: 0,
    },
    {
      monthid: 4,
      value: 0,
    },
    {
      monthid: 5,
      value: 0,
    },
    {
      monthid: 6,
      value: 0,
    },
    {
      monthid: 7,
      value: 0,
    },
    {
      monthid: 8,
      value: 0,
    },
    {
      monthid: 9,
      value: 0,
    },
    {
      monthid: 10,
      value: 0,
    },
    {
      monthid: 11,
      value: 0,
    },
    {
      monthid: 12,
      value: 0,
    },
  ],
  genderids: null,
  employeetypeids: null,
  maritalstatusids: null,
  experienceinmonth: 0,
  isprorate: false,
  proratetypeid: 0,
  creditmodetypeid: 0,
  midjoinstartday: 0,
  isextentionprobation: false,
  creditdaymonth: null,
  othercreditmodetypeid: 0,
  isaccrual: false,
  accuralfrequencytype: 0,
  isunusedforward: false,
  isprobationaccurallimit: false,
  probationaccurallimit: 0,
  isattachment: false,
  attachmentduration: 0,
  attachmentnote: '',
  isfurtureappallowed: false,
  minleavecountforapp: 1,
  notifyinadvanceday: 1,
  notifynotbeforeday: 1,
  ispastappallowed: false,
  apppastday: 1,
  isleaveallowedinnotice: false,
  leavecountinnotice: 1,
  isintervinigallowed: false,
  isclubbingallowed: false,
  clubbingleaveid: null,
  isoverutilizationallowed: false,
  overutilizationpolicy: {
    excessleaveactiontypeid: 0,
    excesspaidlimit: 0,
    altleaveid: 0,
    altexcessleaveactiontypeid: 0,
    altleavetypeid: 0,
  },
  datastate: 1,
};
